import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const HeaderPickersTogglerPromoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
    }
`;

export const HeaderPickersTogglerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-right: 24px;
    }
`;

export const SeasonSelectWrapper = styled.div`
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 188px;
    }
`;

export const HeaderPickersWrapper = styled.div`
    height: 158px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
`;

export const Header = styled.h1`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const PickersWrapper = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.small}
        flex-direction: row;
    }
`;

export const ToggleWrapper = styled.div`
    margin: 24px 0;
`;

export const ConferenceHeaderWrapper = styled.div`
    width: 100%;
`;

export const ConferenceHeader = styled.h5`
    color: ${({ theme }) => theme.Text.primary};
    margin: 0;
`;

export const DivisionHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle2};
    width: 100%;
    margin-top: 12px;
`;

export const StandingsUpdateMessage = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    padding: 24px 0;
`;
